import { useStrictLocalization } from "@faire/web/common/localization";
export var useLoggedOutRetailerNodes = function useLoggedOutRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var loggedOutRetailerNodes = {
    L1: {
      Account: strictLocalize({
        id: "8viWk0",
        defaultMessage: [{
          "type": 0,
          "value": "Configurações da conta (por exemplo, atualizar morada)"
        }]
      }),
      HowFaireWork: strictLocalize({
        id: "6TLwqu",
        defaultMessage: [{
          "type": 0,
          "value": "Como funciona a Faire"
        }]
      }),
      Invoices: strictLocalize({
        id: "t1H2TU",
        defaultMessage: [{
          "type": 0,
          "value": "Faturas e pagamentos"
        }]
      }),
      Items: strictLocalize({
        id: "1qDrDS",
        defaultMessage: [{
          "type": 0,
          "value": "Artigos em falta e danificados"
        }]
      }),
      Orders: strictLocalize({
        id: "9QHKE5",
        defaultMessage: [{
          "type": 0,
          "value": "Estado do pedido"
        }]
      }),
      Returns: strictLocalize({
        id: "Gi6QMt",
        defaultMessage: [{
          "type": 0,
          "value": "Devoluções e reembolsos"
        }]
      }),
      GeneralShipping: strictLocalize({
        id: "ueCCEa",
        defaultMessage: [{
          "type": 0,
          "value": "Questões gerais de envio"
        }]
      }),
      Other: strictLocalize({
        id: "8PmlMt",
        defaultMessage: [{
          "type": 0,
          "value": "Outros problemas do revendedor"
        }]
      })
    },
    L2: {
      ImportFeesAndDuties: strictLocalize({
        id: "Fjt2kE",
        defaultMessage: [{
          "type": 0,
          "value": "Taxas e direitos aduaneiros de importação"
        }]
      }),
      BuyingInternational: strictLocalize({
        id: "16zI+k",
        defaultMessage: [{
          "type": 0,
          "value": "Compras internacional"
        }]
      }),
      Other: strictLocalize({
        id: "mTbErA",
        defaultMessage: [{
          "type": 0,
          "value": "Outro"
        }]
      })
    }
  };
  return loggedOutRetailerNodes;
};